import React from 'react';
import { stats, toolchainSteps } from '../data/site';
export function Toolchain() {
  return <section id="about" className="border-b border-hairline bg-[#fbfbfc]" data-id="element-151" data-mp="1r1aykcrxerys">
      <div className="mx-auto max-w-shell px-4 py-20 sm:px-8" data-id="element-152" data-mp="1cbwnn08pc2ha">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]" data-id="element-153" data-mp="1cdg52u63gjkn">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-154" data-mp="1hbrfb60aww3e">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-muted" data-id="element-155" data-mp="250tvsaj78iwb">
              the unified toolchain
            </p>
            <h2 className="mt-4 text-[clamp(1.9rem,3.6vw,3rem)] font-semibold leading-[1.02] tracking-tightest text-ink" data-id="element-156" data-mp="29yc6o6gs186y">
              Your toolchain should not fight itself
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-muted" data-id="element-157" data-mp="200frn3kpxt3k">
              Most JavaScript setups stack five tools that each re-read your code and disagree
              about it. We are collapsing that stack into one pipeline with shared internals — so
              the thing that lints your file is the thing that builds it.
            </p>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-hairline pt-8 sm:grid-cols-3" data-id="element-158" data-mp="1h3l2psm93f8g">
              {stats.map(s => <div key={s.label} className="flex flex-col-reverse" data-id="element-159" data-mp="1v4nr4c0px1mj">
                  <dt className="mt-2 font-mono text-xs uppercase leading-snug tracking-[0.12em] text-muted" data-id="element-160" data-mp="1q3q9q1nj8bm3">
                    {s.label}
                  </dt>
                  <dd className="text-4xl font-semibold tracking-tightest text-ink sm:text-5xl" data-id="element-161" data-mp="20275rd1bvgf0">
                    {s.value}
                  </dd>
                </div>)}
            </dl>
          </div>

          <ol className="relative" data-id="element-162" data-mp="29rgxusw68z34">
            <span aria-hidden="true" className="absolute left-[13px] top-2 bottom-2 w-px bg-hairline" data-id="element-163" data-mp="29ta9kmln69hz" />
            {toolchainSteps.map((step, i) => <li key={step.label} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-164" data-mp="2itzyd6chizm7" data-mpi={i}>
                <span className="relative z-10 mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-full border border-hairline bg-white font-mono text-[11px] text-void" data-id="element-165" data-mp="1gg26ja69qizf">
                  {i + 1}
                </span>
                <div data-id="element-166" data-mp="1pee3rv1n4f0u">
                  <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-void" data-id="element-167" data-mp="1pdukob097kl8">
                    {step.label}
                  </p>
                  <h3 className="mt-2 text-xl font-semibold tracking-tight text-ink" data-id="element-168" data-mp="1z6jsmvwligbt">
                    {step.title}
                  </h3>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted" data-id="element-169" data-mp="2430ka0307ctn">{step.body}</p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}